import React from "react";
import reactLogo from "../../assets/images/logo.svg";
import nodeLogo from "../../assets/images/nodejs-icon.svg";
import jSLogo from "../../assets/images/logo-javascript.svg";
import sassLogo from "../../assets/images/sass-logo.svg";
import htmlLogo from "../../assets/images/html5-logo.svg";
import nextLogo from "../../assets/images/next-js.svg";
import tsLogo from "../../assets/images/ts.svg";
import cssLogo from "../../assets/images/css3.svg";
import reduxLogo from "../../assets/images/redux.svg";
import gitLogo from "../../assets/images/git.svg";

import styled from "@emotion/styled";
import { SectionHeading, StyledSectionContainer } from "../layout/Layout";

const Stack = () => {
  return (
    <StyledWrapper>
      <StyledSectionContainer>
        <div className={"section-flex"}>
          <SectionHeading
            title="Tools I work with"
            description={
              <span>
                {" "}
                Here are some of the frameworks, libraries and tools i work with
                to get projects done. But i am not limited to a tool, i pick up
                new tools and libraries that tend to solve a problem i am
                working on and learn it on the go. You can say i'm{" "}
                <b>'Stackless'</b>
              </span>
            }
          />

          <div className={"stack-wrapper"}>
            <img src={htmlLogo} alt="HTML logo" />
            <img src={cssLogo} alt="CSS logo" />
            <img src={jSLogo} alt="JS Logo" />
            <img src={tsLogo} alt="TS Logo" />
            <img src={gitLogo} alt="git Logo" />
            <img src={reactLogo} id={"react-logo"} alt="React logo" />
            <img src={nodeLogo} alt="NODEjs Logo" />
            <img src={reduxLogo} alt="TS Logo" />

            <img src={sassLogo} alt="SASS Logo" />
            <img src={nextLogo} alt="NEXTjs Logo" />
          </div>
        </div>
      </StyledSectionContainer>
    </StyledWrapper>
  );
};

export default Stack;

const StyledWrapper = styled.section`
  background-color: #1e1d1d;
  /* position: absolute; */
  width: 100%;
  /* padding: 4rem 2rem; */
  /* transform: translateY(220px); */
  /* box-shadow: 0 0 10px 10px #4d4d4d29; */
  z-index: 3;
  /* border-radius: 1rem; */
  color: #fff;

  & .section-flex {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 40px;
  }

  & .stack-wrapper {
    display: flex;
    /* justify-content: center; */
    align-items: center;
    gap: 40px;
    width: 100%;
    flex-wrap: wrap;
  }
  & .stack-section-title {
    font-size: 4rem;
    /* text-align: center; */
    /* margin-bottom: 2.5rem; */
  }
  & .subtitle {
    font-size: 1.2rem;
    max-width: 900px;
  }

  .stack-wrapper img {
    width: 5%;
  }

  #react-logo {
    width: 10%;
  }

  @media screen and (max-width: 769px) {
    transform: unset;
    /* margin-bottom: -100px; */

    .header-banner {
      padding: 1.5rem;
    }
    .banner-content-wrapper {
      flex-direction: column;
      align-items: center;
      z-index: 1;
      flex: 1;
    }

    .banner-content {
      width: 100%;
      text-align: center;
    }

    .header-section {
      justify-content: center;
    }

    .about-me {
      max-width: 80%;
      margin: 0 auto 2rem auto;
    }
    .user-img-wrapper {
      /* position: absolute; */
      /* width: 100%; */
      /* height: 100%; */
      z-index: 1;
      margin-top: 2rem;
      /* right: calc(-50%); */
    }

    .download-btn {
      text-align: center;
      width: fit-content;
      margin: 0 auto;
    }

    .stack-wrapper img {
      width: 7%;
    }
  }

  /* @media screen and (min-width: 1px) {


    .stack-section-title {
      font-size: 4.5vw;
    }
    .stack-wrapper img {
      width: 13%;
    }
    #react-logo {
      width: 15%;
    }
  } */

  /* @media screen and (min-width: 350px) {
    .stack-section-title {
      font-size: 1.5rem;
    }
    .stack-wrapper img {
      width: 11%;
    }

    #react-logo {
      width: 13%;
    }
  }

  @media screen and (min-width: 396px) {
    .stack-section-title {
      font-size: 1.6rem;
    }
    .stack-wrapper img {
      width: 50px !important;
    }

    #react-logo {
      width: 90px !important;
    }
  } */
`;
